import { z } from 'zod';

export const ClickupListsSchema = z.record(z.string(), z.string());

export const ClickupConfigSchema = z.object({
  apiToken: z.string().min(1),
  lists: ClickupListsSchema,
  timeoutMs: z.number().int().positive().optional().default(15000),
});

export type ClickupConfigValue = z.infer<typeof ClickupConfigSchema>;

export interface ClickupListConfig {
  id: string;
  key: string;
  name: string;
}

export const parseClickupLists = (value: unknown): ClickupListConfig[] => {
  const result = ClickupConfigSchema.safeParse(value);
  if (!result.success) return [];

  return Object.entries(result.data.lists).map(([key, id]) => ({
    id,
    key,
    name: key,
  }));
};

export interface ClickupTaskStatus {
  status: string;
  color?: string | null;
  type?: string | null;
}

export interface ClickupTaskAssignee {
  id?: string | number;
  username?: string | null;
  email?: string | null;
  name?: string | null;
  avatar?: string | null;
}

export interface ClickupTaskSummary {
  id: string;
  name: string;
  status: ClickupTaskStatus;
  assignees: ClickupTaskAssignee[];
  dueDate?: string | null;
  url?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface ClickupCommentAuthor {
  id?: string | number;
  name?: string | null;
  email?: string | null;
  avatar?: string | null;
}

export interface ClickupComment {
  id: string;
  text: string;
  createdAt?: string | null;
  author?: ClickupCommentAuthor | null;
}

export interface ClickupTaskDetails extends ClickupTaskSummary {
  description?: string | null;
  comments: ClickupComment[];
  clientEmail?: string | null;
}
